/* eslint-disable */
// This file generated by `npm run build:generate`, don't edit manually.

import { TxParams as TxParamsComplex, TxParamsAsync as TxParamsAsyncComplex, TxUnpacked as TxUnpackedComplex } from "./schema.js";
import { Tag } from "./constants.js";
/**
 * @category transaction builder
 */
type TxParamsSignedTx1Type = Omit<TxParamsComplex & {
    tag: Tag.SignedTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsSignedTx1 extends TxParamsSignedTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncSignedTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.SignedTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncSignedTx1 extends TxParamsAsyncSignedTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedSignedTx1Type = TxUnpackedComplex & {
    tag: Tag.SignedTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedSignedTx1 extends TxUnpackedSignedTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsSpendTx1Type = Omit<TxParamsComplex & {
    tag: Tag.SpendTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsSpendTx1 extends TxParamsSpendTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncSpendTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.SpendTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncSpendTx1 extends TxParamsAsyncSpendTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedSpendTx1Type = TxUnpackedComplex & {
    tag: Tag.SpendTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedSpendTx1 extends TxUnpackedSpendTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsNamePreclaimTx1Type = Omit<TxParamsComplex & {
    tag: Tag.NamePreclaimTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsNamePreclaimTx1 extends TxParamsNamePreclaimTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncNamePreclaimTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.NamePreclaimTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncNamePreclaimTx1 extends TxParamsAsyncNamePreclaimTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedNamePreclaimTx1Type = TxUnpackedComplex & {
    tag: Tag.NamePreclaimTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedNamePreclaimTx1 extends TxUnpackedNamePreclaimTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsNameClaimTx2Type = Omit<TxParamsComplex & {
    tag: Tag.NameClaimTx;
    version: 2;
}, "version"> & {
    version?: 2;
};
/**
 * @category transaction builder
 */
export interface TxParamsNameClaimTx2 extends TxParamsNameClaimTx2Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncNameClaimTx2Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.NameClaimTx;
    version: 2;
}, "version"> & {
    version?: 2;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncNameClaimTx2 extends TxParamsAsyncNameClaimTx2Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedNameClaimTx2Type = TxUnpackedComplex & {
    tag: Tag.NameClaimTx;
    version: 2;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedNameClaimTx2 extends TxUnpackedNameClaimTx2Type {
}
/**
 * @category transaction builder
 */
type TxParamsNameUpdateTx1Type = Omit<TxParamsComplex & {
    tag: Tag.NameUpdateTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsNameUpdateTx1 extends TxParamsNameUpdateTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncNameUpdateTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.NameUpdateTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncNameUpdateTx1 extends TxParamsAsyncNameUpdateTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedNameUpdateTx1Type = TxUnpackedComplex & {
    tag: Tag.NameUpdateTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedNameUpdateTx1 extends TxUnpackedNameUpdateTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsNameUpdateTx2Type = TxParamsComplex & {
    tag: Tag.NameUpdateTx;
    version: 2;
};
/**
 * @category transaction builder
 */
export interface TxParamsNameUpdateTx2 extends TxParamsNameUpdateTx2Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncNameUpdateTx2Type = TxParamsAsyncComplex & {
    tag: Tag.NameUpdateTx;
    version: 2;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncNameUpdateTx2 extends TxParamsAsyncNameUpdateTx2Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedNameUpdateTx2Type = TxUnpackedComplex & {
    tag: Tag.NameUpdateTx;
    version: 2;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedNameUpdateTx2 extends TxUnpackedNameUpdateTx2Type {
}
/**
 * @category transaction builder
 */
type TxParamsNameTransferTx1Type = Omit<TxParamsComplex & {
    tag: Tag.NameTransferTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsNameTransferTx1 extends TxParamsNameTransferTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncNameTransferTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.NameTransferTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncNameTransferTx1 extends TxParamsAsyncNameTransferTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedNameTransferTx1Type = TxUnpackedComplex & {
    tag: Tag.NameTransferTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedNameTransferTx1 extends TxUnpackedNameTransferTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsNameRevokeTx1Type = Omit<TxParamsComplex & {
    tag: Tag.NameRevokeTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsNameRevokeTx1 extends TxParamsNameRevokeTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncNameRevokeTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.NameRevokeTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncNameRevokeTx1 extends TxParamsAsyncNameRevokeTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedNameRevokeTx1Type = TxUnpackedComplex & {
    tag: Tag.NameRevokeTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedNameRevokeTx1 extends TxUnpackedNameRevokeTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsContractCreateTx1Type = Omit<TxParamsComplex & {
    tag: Tag.ContractCreateTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsContractCreateTx1 extends TxParamsContractCreateTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncContractCreateTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.ContractCreateTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncContractCreateTx1 extends TxParamsAsyncContractCreateTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedContractCreateTx1Type = TxUnpackedComplex & {
    tag: Tag.ContractCreateTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedContractCreateTx1 extends TxUnpackedContractCreateTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsContractCallTx1Type = Omit<TxParamsComplex & {
    tag: Tag.ContractCallTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsContractCallTx1 extends TxParamsContractCallTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncContractCallTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.ContractCallTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncContractCallTx1 extends TxParamsAsyncContractCallTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedContractCallTx1Type = TxUnpackedComplex & {
    tag: Tag.ContractCallTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedContractCallTx1 extends TxUnpackedContractCallTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsOracleRegisterTx1Type = Omit<TxParamsComplex & {
    tag: Tag.OracleRegisterTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsOracleRegisterTx1 extends TxParamsOracleRegisterTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncOracleRegisterTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.OracleRegisterTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncOracleRegisterTx1 extends TxParamsAsyncOracleRegisterTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedOracleRegisterTx1Type = TxUnpackedComplex & {
    tag: Tag.OracleRegisterTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedOracleRegisterTx1 extends TxUnpackedOracleRegisterTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsOracleExtendTx1Type = Omit<TxParamsComplex & {
    tag: Tag.OracleExtendTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsOracleExtendTx1 extends TxParamsOracleExtendTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncOracleExtendTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.OracleExtendTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncOracleExtendTx1 extends TxParamsAsyncOracleExtendTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedOracleExtendTx1Type = TxUnpackedComplex & {
    tag: Tag.OracleExtendTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedOracleExtendTx1 extends TxUnpackedOracleExtendTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsOracleQueryTx1Type = Omit<TxParamsComplex & {
    tag: Tag.OracleQueryTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsOracleQueryTx1 extends TxParamsOracleQueryTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncOracleQueryTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.OracleQueryTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncOracleQueryTx1 extends TxParamsAsyncOracleQueryTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedOracleQueryTx1Type = TxUnpackedComplex & {
    tag: Tag.OracleQueryTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedOracleQueryTx1 extends TxUnpackedOracleQueryTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsOracleRespondTx1Type = Omit<TxParamsComplex & {
    tag: Tag.OracleRespondTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsOracleRespondTx1 extends TxParamsOracleRespondTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncOracleRespondTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.OracleRespondTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncOracleRespondTx1 extends TxParamsAsyncOracleRespondTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedOracleRespondTx1Type = TxUnpackedComplex & {
    tag: Tag.OracleRespondTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedOracleRespondTx1 extends TxUnpackedOracleRespondTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsChannelCreateTx2Type = Omit<TxParamsComplex & {
    tag: Tag.ChannelCreateTx;
    version: 2;
}, "version"> & {
    version?: 2;
};
/**
 * @category transaction builder
 */
export interface TxParamsChannelCreateTx2 extends TxParamsChannelCreateTx2Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncChannelCreateTx2Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.ChannelCreateTx;
    version: 2;
}, "version"> & {
    version?: 2;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncChannelCreateTx2 extends TxParamsAsyncChannelCreateTx2Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedChannelCreateTx2Type = TxUnpackedComplex & {
    tag: Tag.ChannelCreateTx;
    version: 2;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedChannelCreateTx2 extends TxUnpackedChannelCreateTx2Type {
}
/**
 * @category transaction builder
 */
type TxParamsChannelCloseMutualTx1Type = Omit<TxParamsComplex & {
    tag: Tag.ChannelCloseMutualTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsChannelCloseMutualTx1 extends TxParamsChannelCloseMutualTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncChannelCloseMutualTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.ChannelCloseMutualTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncChannelCloseMutualTx1 extends TxParamsAsyncChannelCloseMutualTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedChannelCloseMutualTx1Type = TxUnpackedComplex & {
    tag: Tag.ChannelCloseMutualTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedChannelCloseMutualTx1 extends TxUnpackedChannelCloseMutualTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsChannelCloseSoloTx1Type = Omit<TxParamsComplex & {
    tag: Tag.ChannelCloseSoloTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsChannelCloseSoloTx1 extends TxParamsChannelCloseSoloTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncChannelCloseSoloTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.ChannelCloseSoloTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncChannelCloseSoloTx1 extends TxParamsAsyncChannelCloseSoloTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedChannelCloseSoloTx1Type = TxUnpackedComplex & {
    tag: Tag.ChannelCloseSoloTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedChannelCloseSoloTx1 extends TxUnpackedChannelCloseSoloTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsChannelSlashTx1Type = Omit<TxParamsComplex & {
    tag: Tag.ChannelSlashTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsChannelSlashTx1 extends TxParamsChannelSlashTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncChannelSlashTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.ChannelSlashTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncChannelSlashTx1 extends TxParamsAsyncChannelSlashTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedChannelSlashTx1Type = TxUnpackedComplex & {
    tag: Tag.ChannelSlashTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedChannelSlashTx1 extends TxUnpackedChannelSlashTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsChannelDepositTx1Type = Omit<TxParamsComplex & {
    tag: Tag.ChannelDepositTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsChannelDepositTx1 extends TxParamsChannelDepositTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncChannelDepositTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.ChannelDepositTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncChannelDepositTx1 extends TxParamsAsyncChannelDepositTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedChannelDepositTx1Type = TxUnpackedComplex & {
    tag: Tag.ChannelDepositTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedChannelDepositTx1 extends TxUnpackedChannelDepositTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsChannelWithdrawTx1Type = Omit<TxParamsComplex & {
    tag: Tag.ChannelWithdrawTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsChannelWithdrawTx1 extends TxParamsChannelWithdrawTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncChannelWithdrawTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.ChannelWithdrawTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncChannelWithdrawTx1 extends TxParamsAsyncChannelWithdrawTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedChannelWithdrawTx1Type = TxUnpackedComplex & {
    tag: Tag.ChannelWithdrawTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedChannelWithdrawTx1 extends TxUnpackedChannelWithdrawTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsChannelSettleTx1Type = Omit<TxParamsComplex & {
    tag: Tag.ChannelSettleTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsChannelSettleTx1 extends TxParamsChannelSettleTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncChannelSettleTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.ChannelSettleTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncChannelSettleTx1 extends TxParamsAsyncChannelSettleTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedChannelSettleTx1Type = TxUnpackedComplex & {
    tag: Tag.ChannelSettleTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedChannelSettleTx1 extends TxUnpackedChannelSettleTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsChannelForceProgressTx1Type = Omit<TxParamsComplex & {
    tag: Tag.ChannelForceProgressTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsChannelForceProgressTx1 extends TxParamsChannelForceProgressTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncChannelForceProgressTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.ChannelForceProgressTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncChannelForceProgressTx1 extends TxParamsAsyncChannelForceProgressTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedChannelForceProgressTx1Type = TxUnpackedComplex & {
    tag: Tag.ChannelForceProgressTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedChannelForceProgressTx1 extends TxUnpackedChannelForceProgressTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsChannelOffChainTx2Type = Omit<TxParamsComplex & {
    tag: Tag.ChannelOffChainTx;
    version: 2;
}, "version"> & {
    version?: 2;
};
/**
 * @category transaction builder
 */
export interface TxParamsChannelOffChainTx2 extends TxParamsChannelOffChainTx2Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncChannelOffChainTx2Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.ChannelOffChainTx;
    version: 2;
}, "version"> & {
    version?: 2;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncChannelOffChainTx2 extends TxParamsAsyncChannelOffChainTx2Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedChannelOffChainTx2Type = TxUnpackedComplex & {
    tag: Tag.ChannelOffChainTx;
    version: 2;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedChannelOffChainTx2 extends TxUnpackedChannelOffChainTx2Type {
}
/**
 * @category transaction builder
 */
type TxParamsChannelSnapshotSoloTx1Type = Omit<TxParamsComplex & {
    tag: Tag.ChannelSnapshotSoloTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsChannelSnapshotSoloTx1 extends TxParamsChannelSnapshotSoloTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncChannelSnapshotSoloTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.ChannelSnapshotSoloTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncChannelSnapshotSoloTx1 extends TxParamsAsyncChannelSnapshotSoloTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedChannelSnapshotSoloTx1Type = TxUnpackedComplex & {
    tag: Tag.ChannelSnapshotSoloTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedChannelSnapshotSoloTx1 extends TxUnpackedChannelSnapshotSoloTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsGaAttachTx1Type = Omit<TxParamsComplex & {
    tag: Tag.GaAttachTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsGaAttachTx1 extends TxParamsGaAttachTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncGaAttachTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.GaAttachTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncGaAttachTx1 extends TxParamsAsyncGaAttachTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedGaAttachTx1Type = TxUnpackedComplex & {
    tag: Tag.GaAttachTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedGaAttachTx1 extends TxUnpackedGaAttachTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsGaMetaTx2Type = Omit<TxParamsComplex & {
    tag: Tag.GaMetaTx;
    version: 2;
}, "version"> & {
    version?: 2;
};
/**
 * @category transaction builder
 */
export interface TxParamsGaMetaTx2 extends TxParamsGaMetaTx2Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncGaMetaTx2Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.GaMetaTx;
    version: 2;
}, "version"> & {
    version?: 2;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncGaMetaTx2 extends TxParamsAsyncGaMetaTx2Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedGaMetaTx2Type = TxUnpackedComplex & {
    tag: Tag.GaMetaTx;
    version: 2;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedGaMetaTx2 extends TxUnpackedGaMetaTx2Type {
}
/**
 * @category transaction builder
 */
type TxParamsPayingForTx1Type = Omit<TxParamsComplex & {
    tag: Tag.PayingForTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsPayingForTx1 extends TxParamsPayingForTx1Type {
}
/**
 * @category transaction builder
 */
type TxParamsAsyncPayingForTx1Type = Omit<TxParamsAsyncComplex & {
    tag: Tag.PayingForTx;
    version: 1;
}, "version"> & {
    version?: 1;
};
/**
 * @category transaction builder
 */
export interface TxParamsAsyncPayingForTx1 extends TxParamsAsyncPayingForTx1Type {
}
/**
 * @category transaction builder
 */
type TxUnpackedPayingForTx1Type = TxUnpackedComplex & {
    tag: Tag.PayingForTx;
    version: 1;
};
/**
 * @category transaction builder
 */
export interface TxUnpackedPayingForTx1 extends TxUnpackedPayingForTx1Type {
}
/**
 * @category transaction builder
 */
export type TxParams = TxParamsSignedTx1 | TxParamsSpendTx1 | TxParamsNamePreclaimTx1 | TxParamsNameClaimTx2 | TxParamsNameUpdateTx1 | TxParamsNameUpdateTx2 | TxParamsNameTransferTx1 | TxParamsNameRevokeTx1 | TxParamsContractCreateTx1 | TxParamsContractCallTx1 | TxParamsOracleRegisterTx1 | TxParamsOracleExtendTx1 | TxParamsOracleQueryTx1 | TxParamsOracleRespondTx1 | TxParamsChannelCreateTx2 | TxParamsChannelCloseMutualTx1 | TxParamsChannelCloseSoloTx1 | TxParamsChannelSlashTx1 | TxParamsChannelDepositTx1 | TxParamsChannelWithdrawTx1 | TxParamsChannelSettleTx1 | TxParamsChannelForceProgressTx1 | TxParamsChannelOffChainTx2 | TxParamsChannelSnapshotSoloTx1 | TxParamsGaAttachTx1 | TxParamsGaMetaTx2 | TxParamsPayingForTx1;
/**
 * @category transaction builder
 */
export type TxParamsAsync = TxParamsAsyncSignedTx1 | TxParamsAsyncSpendTx1 | TxParamsAsyncNamePreclaimTx1 | TxParamsAsyncNameClaimTx2 | TxParamsAsyncNameUpdateTx1 | TxParamsAsyncNameUpdateTx2 | TxParamsAsyncNameTransferTx1 | TxParamsAsyncNameRevokeTx1 | TxParamsAsyncContractCreateTx1 | TxParamsAsyncContractCallTx1 | TxParamsAsyncOracleRegisterTx1 | TxParamsAsyncOracleExtendTx1 | TxParamsAsyncOracleQueryTx1 | TxParamsAsyncOracleRespondTx1 | TxParamsAsyncChannelCreateTx2 | TxParamsAsyncChannelCloseMutualTx1 | TxParamsAsyncChannelCloseSoloTx1 | TxParamsAsyncChannelSlashTx1 | TxParamsAsyncChannelDepositTx1 | TxParamsAsyncChannelWithdrawTx1 | TxParamsAsyncChannelSettleTx1 | TxParamsAsyncChannelForceProgressTx1 | TxParamsAsyncChannelOffChainTx2 | TxParamsAsyncChannelSnapshotSoloTx1 | TxParamsAsyncGaAttachTx1 | TxParamsAsyncGaMetaTx2 | TxParamsAsyncPayingForTx1;
/**
 * @category transaction builder
 */
export type TxUnpacked = TxUnpackedSignedTx1 | TxUnpackedSpendTx1 | TxUnpackedNamePreclaimTx1 | TxUnpackedNameClaimTx2 | TxUnpackedNameUpdateTx1 | TxUnpackedNameUpdateTx2 | TxUnpackedNameTransferTx1 | TxUnpackedNameRevokeTx1 | TxUnpackedContractCreateTx1 | TxUnpackedContractCallTx1 | TxUnpackedOracleRegisterTx1 | TxUnpackedOracleExtendTx1 | TxUnpackedOracleQueryTx1 | TxUnpackedOracleRespondTx1 | TxUnpackedChannelCreateTx2 | TxUnpackedChannelCloseMutualTx1 | TxUnpackedChannelCloseSoloTx1 | TxUnpackedChannelSlashTx1 | TxUnpackedChannelDepositTx1 | TxUnpackedChannelWithdrawTx1 | TxUnpackedChannelSettleTx1 | TxUnpackedChannelForceProgressTx1 | TxUnpackedChannelOffChainTx2 | TxUnpackedChannelSnapshotSoloTx1 | TxUnpackedGaAttachTx1 | TxUnpackedGaMetaTx2 | TxUnpackedPayingForTx1;
